import { ViewController } from 'ionic-angular/navigation/view-controller';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import {  NavController, NavParams } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';
@Component({
  selector: 'page-servishareketduzenle',
  templateUrl: 'servishareketduzenle.html',
})
export class ServishareketduzenlePage {
  vWKayit: any = {};
  gelenkayit: any = { ID: -1 };
  hareketdetay: any = { ID: 1, ServiceID: "", YapilanIslem: "", Maliyet: "", HareketTarihi: "", Aciklama: "" };
  islemyapan = this.ortak.storagePersonelGetir.Name;
  constructor(public navCtrl: NavController,
    public bllOrtak: BllOrtak,
    public viewCtrl: ViewController,
    public ortak: Ortak,
    public navParams: NavParams) {
    if (navParams.get("vWKayit") != null) {
      this.vWKayit = navParams.get("vWKayit");
      var data = new FormData();
      data.append("Servis_id", this.vWKayit.ID);
      this.bllOrtak.islem(data, "HareketDetayGetirByID", "", false).then(a => {
        var Sonuc = <any>a;
        this.hareketdetay = Sonuc.SonucObject;
      });
    }
  }
  kapat() {
    this.viewCtrl.dismiss();
  }
  kaydet() {
    var formData = new FormData();
    formData.append("hareket_json", JSON.stringify(this.hareketdetay, this.hareketdetay.IslemYapan = this.islemyapan));
     this.bllOrtak.islem(formData, "ServisHareketEkle", "", false).then(a => {
      var sonuc = <any>a;
      if (sonuc.Sonuc == 1) this.ortak.showBasicAlert("Başarılı", "İşlem Başarılı");
      this.viewCtrl.dismiss();
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/ServisKayit/servishareketduzenle/servishareketduzenle.ts